import { usePlan } from "../utils/planUtils";
import SnapshotPage_free from "./freemium/SnapshotPage_free";
import PortfolioExplorationPage from "./pro/PortfolioExplorationPage";

/**
 * HomePage - Unified Home Component
 *
 * This component stays at /home and conditionally renders either the
 * freemium or pro snapshot view based on the user's entitlement.
 *
 * Key features:
 * - Stays at /home URL (no redirects)
 * - Plan determined by entitlement.plan_id from AuthContext
 * - Snapshot pages are rendered as components, not routes
 * - Real-time updates when entitlement changes
 */
export default function HomePage() {
  // Get plan from entitlement (single source of truth)
  const { plan, isLoading } = usePlan();

  console.log('🏠 HomePage - Rendering with plan:', plan);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#FF6E4C] mx-auto mb-4"></div>
          <p className="text-slate-600">Loading your experience...</p>
        </div>
      </div>
    );
  }

  return (
    <>
      {/* Conditional Content Based on Plan - Renders as components, not routes */}
      {/* Use plan as key to force complete re-mount when switching */}
      {plan === 'pro' ? (
        <PortfolioExplorationPage key="portfolio-pro" />
      ) : (
        <SnapshotPage_free key="snapshot-freemium" />
      )}
    </>
  );
}
